import React, {useEffect, useState} from 'react'
import Popover from "@mui/material/Popover"
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import classnames from "classnames"

import fetcher from "../fetcher"
import {getAmountDueAtSigningRows} from "../pages/DealPage/DisclosurePDFs/components/AmountDueAtSigningPDF"
import './AmountDueBreakdownPopover.scss'

const Row = ({label, amount, className}) => (
    <div className={classnames('adb-row', className)}>
        <span className={'adb-label'}>{label}</span>
        <span className={'adb-value'}>{amount.toDollarFormat()}</span>
    </div>
)

/**
 * Opened from the lease Amount Due at Signing field: the Dealer Worksheet's
 * Amount Due at Signing rows, read-only. The rows come from the worksheet's
 * data (fetched on open), never from a calculation here.
 */
export const AmountDueBreakdownPopover = ({anchorEl, dealId, onClose}) => {
    // undefined while loading, null if the request failed.
    const [pdfData, setPdfData] = useState(undefined)

    useEffect(function fetchWorksheetData(){
        fetcher.getPDF(dealId)
            .then((res) => setPdfData(res.data))
            .catch(() => setPdfData(null))
    }, [dealId])

    const rows = pdfData && getAmountDueAtSigningRows(pdfData)

    return (
        <Popover
            open={true}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
            slotProps={{paper: {className: 'AmountDueBreakdownPopover-paper'}}}
            // Keep the Deal page's document-level Enter from re-running Calculate.
            // On the Popover, not the card: focus sits on the Paper around it.
            onKeyDown={(e) => e.key === 'Enter' && e.stopPropagation()}
        >
            <div className={'AmountDueBreakdownPopover'} data-testid={'amount-due-breakdown-popover'}>
                <div className={'adb-header'}>
                    <ReceiptLongIcon/>
                    <h2>Amount Due at Signing</h2>
                </div>
                {
                    rows
                        ? <div className={'adb-body'}>
                            <div className={'adb-section-label'}>Inception Fees</div>
                            {rows.items.map((v, i) => <Row key={i} {...v}/>)}
                            <Row className={'adb-subtotal'} label={'Total Inception Fees'} amount={rows.totalInceptionFees}/>
                            {
                                rows.adjustments.length > 0 &&
                                <>
                                    <div className={'adb-section-label'}>Adjustments</div>
                                    {rows.adjustments.map((v) => <Row key={v.label} {...v}/>)}
                                </>
                            }
                            <Row className={'adb-total'} label={'Total Drive Off'} amount={rows.totalDriveOff}/>
                          </div>
                        : <div className={'adb-status'}>
                            {pdfData === null ? 'Could not load breakdown.' : 'Loading…'}
                          </div>
                }
            </div>
        </Popover>
    )
}
